import { render, staticRenderFns } from "./DecisionModal.vue?vue&type=template&id=46af49f9&scoped=true"
import script from "./DecisionModal.vue?vue&type=script&lang=js"
export * from "./DecisionModal.vue?vue&type=script&lang=js"
import style0 from "./DecisionModal.vue?vue&type=style&index=0&id=46af49f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af49f9",
  null
  
)

export default component.exports